import React from "react"

// @ts-ignore
// @ts-ignore
import SelectMultiGeneric from "../../../gd-ui/select-multi-generic/select-multi-generic"
import Select from "../../../gd-form/form-element/select-new/select-new";
import {PortfolioConditionType, projectStatusOptions, projectTypeOptions} from "./@const";
import PortfolioCondition from "./portfolio-condition";
import {SystemStatus, SystemStatuses, SystemStatusGroup,} from "../../../gd/const/system-status";
import {SelectParent_RenderType} from "../../../gd-ui/select-parent-new/@const";
import {EntityType} from "../../../gd/const/item";
import SelectParentsNew from "../../../gd-ui/select-parent-new/select-parents-new";

type Props = {
    type                        : any
    form                        : any

    disabled?                   : boolean

    onTypeChanged               : callback
    onProjectsChanged           : callback
    onProjectTypesChanged       : callback

    onProjectsStatusChanged?    : callback

    parent                      : PortfolioCondition
}

type State = {
    type                    : PortfolioConditionType
    projectIds              : ID[]
    parentProjectIds        : ID[]
    projectTypes            : ID[]
    systemStatusesGroup   : SystemStatus[]
}

export default class PortfolioConditionForm extends React.Component<Props, State> {

    constructor(props:Props) {
        super(props);

        this.state = {
            type                    : props.type,
            projectIds              : props.form.getValue('settings').projectIds,
            parentProjectIds        : props.form.getValue('settings').parentProjectIds,
            projectTypes            : this.props.form.getValue('settings').projectTypes,
            systemStatusesGroup     : this.props.form.getValue('settings').systemStatusesGroup || SystemStatuses[SystemStatusGroup.ALL]
        }
    }

    changeType = (value: PortfolioConditionType) => {
        if (this.props.onTypeChanged) this.props.onTypeChanged(value)

        this.setState({
            type                : value,
            projectTypes        : value === PortfolioConditionType.MANUAL ? [] : this.state.projectTypes,
            projectIds          : value === PortfolioConditionType.ALL_IN_PARENTS ? [] : this.state.projectIds,
            parentProjectIds    : value === PortfolioConditionType.ALL_IN_PARENTS ? this.state.parentProjectIds : [],
        })
    }

    _setSettings = () => {
        let settings = {projectIds: [], projectTypes: []}

        if (!_.isEmpty(this.state.projectIds))          settings = _.assign(settings, {projectIds: this.state.projectIds})
        if (!_.isEmpty(this.state.parentProjectIds))    settings = _.assign(settings, {parentProjectIds: this.state.parentProjectIds})
        if (!_.isEmpty(this.state.projectTypes))        settings = _.assign(settings, {projectTypes: this.state.projectTypes})
        //New
        if (this.state.type === PortfolioConditionType.MANUAL) {
            settings = _.assign(settings, SystemStatusGroup.OPEN)
        } else {
            settings = _.assign(settings, {systemStatusesGroup: this.state.systemStatusesGroup})
        }

        this.props.form.onFormComponentValueChange('settings', settings)
    }

    _setSettingsForParentBased = (parentProjectIds:ID[]) => {
        let settings = {
            projectIds          : [],
            projectTypes        : [],
            parentProjectIds    : parentProjectIds,
            systemStatusesGroup : this.state.systemStatusesGroup
        }
        this.props.form.onFormComponentValueChange('settings', settings)
    }

    onProjectsSelect = (projectIds: ID[]) => {
        if (this.props.onProjectsChanged) this.props.onProjectsChanged(projectIds)

        this.setState(
            {
                projectIds: projectIds,
                projectTypes: []
            },
            ()=>{
                this._setSettings()
            }
        )
    }

    onProjectTypesSelect = (projectTypes:ID[]) => {
        if (this.props.onProjectTypesChanged) this.props.onProjectTypesChanged(projectTypes)
        this.setState({projectIds: [], projectTypes: projectTypes}, ()=>{
            this._setSettings()
        })
    }

    onSelectProjectStatus = (systemStatusesGroup: SystemStatus[]) => {

        if (this.props.onProjectsStatusChanged) this.props.onProjectsStatusChanged(systemStatusesGroup)

        this.setState({
            systemStatusesGroup: systemStatusesGroup,
            parentProjectIds: this.state.parentProjectIds
        }, ()=>{
            this._setSettings()
        })
    }

    // Render

    renderProjectsSelector() {
        if (this.state.type !== PortfolioConditionType.MANUAL) return

        return (
            <>
                <SelectParentsNew renderType                    = {SelectParent_RenderType.FORM}
                                  placeholder                   = "Select projects"
                                  parentsFor                    = {EntityType.PROJECT}
                                  projectIds                    = {this.state.projectIds}
                                  inheritedChildrenSelection    = {false}
                                  disabled                      = {this.props.disabled}
                                  onChange                      = {this.onProjectsSelect}/>

                {/*<SelectParent companies                     = {[gd.companyId]}
                              viewMode                      = "projects"
                              parentsFor                    = {ProjectSystemType.FOLDER}
                              placeholder                   = "Select projects"
                              values                        = {{projects: this.props.form.getValue('settings').projectIds}}
                              multiselect                   = {true}
                              singleCompanyVisible          = {false}
                              searchable                    = {true}
                              updateExpandedOnReceiveProps  = {false}
                              disabled                      = {this.props.disabled}
                              onChange                      = {this.onProjectsSelect} />*/}
            </>
        )
    }

    renderProjectTypesSelector() {
        if (this.state.type !== PortfolioConditionType.PROJECT_TYPES) return

        const projectTypes = _.chain(gd.session.templatesList.models)
            .filter(t=>t.companyId === gd.companyId && !t.isDeleted)
            .orderBy(t=>t.sortPosition)
            .map(t=>({value: t.id, label: t.name}))
            .value()

        return (
            <SelectMultiGeneric className   = "w-300"
                                values      = {this.state.projectTypes}
                                options     = {projectTypes}
                                renderValue = "form"
                                placeholder = "Select project types"
                                searchable  = {false}
                                disabled    = {this.props.disabled}
                                onUserSelect= {this.onProjectTypesSelect}/>
        )
    }

    renderParentFoldersSelector() {

        const onChange = (projectIds: ID[]) => {
            this.props.parent.onParentProjectIdsChanged(projectIds)
            this.setState({parentProjectIds: projectIds})

            this._setSettingsForParentBased(projectIds)
        }

        const currentParentIds = this.props.parent.parentProjectIds

        return (
            <>
                <SelectParentsNew renderType    = {SelectParent_RenderType.FORM}
                                  placeholder   = "Select parent folder(s)"
                                  parentsFor    = {EntityType.PROJECT}
                                  projectIds    = {currentParentIds}
                                  displayWorkspaceRoot   = {true}
                                  disabled      = {this.props.disabled}
                                  onChange      = {onChange}/>

                {/*<SelectParent companies                     = {[gd.companyId]}
                              viewMode                      = "projects"
                              parentsFor                    = {ProjectSystemType.FOLDER}
                              placeholder                   = "Select parent folder(s)"
                              values                        = {{projects: currentParentIds}}
                              multiselect                   = {true}
                              singleCompanyVisible          = {false}
                              searchable                    = {true}
                              updateExpandedOnReceiveProps  = {false}
                              disabled                      = {this.props.disabled}
                              onChange                      = {onChange} />*/}
            </>
        )
    }

    renderProjectStatuses = ()=> {

        // const show: boolean =   this.state.type === PortfolioConditionType.PROJECT_TYPES ||
        //                         this.state.type === PortfolioConditionType.ALL_IN_PARENTS
        //
        // if (!show) return null

        return (
            <Select size            = "big"
                    options         = {projectStatusOptions}
                    value           = {this.state.systemStatusesGroup}
                    onUserSelect    = {this.onSelectProjectStatus}/>
        )
    }

    render() {

        const showSystemStatus: boolean =   this.state.type === PortfolioConditionType.PROJECT_TYPES || this.state.type === PortfolioConditionType.ALL_IN_PARENTS

        return (
            <>
                <div className="row">
                    <div className="label">Projects</div>
                    <div className="element">
                        <Select size="big"
                                options={projectTypeOptions}
                                value={this.state.type}
                                disabled={this.props.disabled}
                                onUserSelect={this.changeType}/>

                        <div className="m-t-10">
                            {this.renderProjectsSelector()}
                            {this.renderProjectTypesSelector()}

                            {this.state.type === PortfolioConditionType.ALL_IN_PARENTS &&
                                this.renderParentFoldersSelector()
                            }

                        </div>
                    </div>
                </div>

                {showSystemStatus &&
                    <div className="row">
                        <div className="label">System Status</div>
                        <div className="element">
                            {this.renderProjectStatuses()}
                        </div>
                    </div>
                }


            </>
        )
    }
}
